import axiosInstance from ".";

export const getFreeTrial = async () => {
  return axiosInstance.get("/admin/free-trial");
};

export const updateFreeTrial = (data) => {
  return axiosInstance.put("/admin/free-trial", data);
};
